<template>
    <t-section v-bind:schemaName="'productCategory'" v-bind:fields="fields" v-bind:headers="headers"></t-section>
</template>

<script>
    import TSection from '@/components/Sections/Section.vue';
    export default {
        name: "ProductCategorySection",
        components:{
            TSection,
        },
        data() {
            return {
                headers:[
                    { field:"name", name:this.fieldLabel("name", "Назва"), sort:true, router: { field:"id", name:"ProductCategoryPage" }},
                    { field:"code", name:this.fieldLabel("code", "Код"), sort:true,  router: { field:"id", name:"ProductCategoryPage" } },
                ],
                fields:[
                    { field: "name", name: this.fieldLabel("name", "Назва"), type:"string" },
                ],
            }
        },
        methods: {
            fieldLabel(field, fallback) {
                return this.$filters.localize(`ProductCategoryPage.fields.${field}`) || fallback;
            },
        },
    }
</script>
